import { lazy } from "react";
import Loadable from "app/components/Loadable";

const OnboardingList = Loadable(lazy(() => import("./OnboardingList")));
Loadable(lazy(() => import("./OnboardingAdd")));
const OnboardingLanding = Loadable(lazy(() => import("./OnboardingLanding")));

const OnboardingRoutes = [
{ path: "/employee/onboard/:mode/:id", element: <OnboardingLanding /> },
{ path: "/employee/onboard", element: <OnboardingList /> }
// { path: "/employee/onboard/:mode/:id", element: <OnboardingAdd />}
];

export default OnboardingRoutes;